var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(_vm.backgroundImage)?_c('div',{staticClass:"pcg-image-cover",class:_vm.backgroundImageClasses,style:(_vm.backgroundStyle)}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }